import type { components } from '../../api/generated/schema';
import type { NotificationKind, NotificationSetting } from '../../domain/notifications';

type S = components['schemas'];

const KINDS: Record<S['NotificationKindEnum'], NotificationKind> = {
  invite_accepted: 'inviteAccepted',
  invite_received: 'inviteReceived',
  new_listing: 'newListing',
  comment_on_my_listing: 'commentOnMyListing',
  reply_after_my_comment: 'replyAfterMyComment',
  new_message: 'newMessage',
};

const WIRE_KINDS = Object.fromEntries(
  Object.entries(KINDS).map(([wire, kind]) => [kind, wire]),
) as Record<NotificationKind, S['NotificationKindEnum']>;

export function toNotificationSetting(s: S['NotificationSetting']): NotificationSetting {
  return {
    kind: KINDS[s.kind],
    channel: s.channel,
    collectionId: s.collection_id ?? null,
    enabled: s.enabled,
  };
}

export function toNotificationSettingRequest(
  s: NotificationSetting,
): S['NotificationSettingRequest'] {
  return {
    kind: WIRE_KINDS[s.kind],
    channel: s.channel,
    collection_id: s.collectionId,
    enabled: s.enabled,
  };
}
